import { render, staticRenderFns } from "./FriendRequestPanel.vue?vue&type=template&id=14a8391a&scoped=true"
import script from "./FriendRequestPanel.vue?vue&type=script&lang=js"
export * from "./FriendRequestPanel.vue?vue&type=script&lang=js"
import style0 from "./FriendRequestPanel.vue?vue&type=style&index=0&id=14a8391a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8391a",
  null
  
)

export default component.exports